import moment from "moment";
import * as Yup from "yup";

export const pricingValidation = Yup.object().shape({
  prices: Yup.array().when("freeForm", {
  is: true,
  then: (schema) => schema.notRequired().strip(),
  otherwise: (schema) =>
    schema.of(
    Yup.object().shape({
      //   amount: Yup.number()
      //   .transform((value, originalValue) =>
      //     originalValue === "" ? undefined : Number(originalValue)
      //   )
      //   .when("type", {
      //     is: (type) =>
      //       type !== "No Payment Needed" && type !== "Open Amount",
      //     then: (schema) =>
      //       schema
      //         .typeError("Required")
      //         .required("Required")
      //         .min(0, "Amount must be greater than or equal to 0"),
      //     otherwise: (schema) => schema.notRequired(),
      //   }),
      amount: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : Number(originalValue),
        )
        .when(["type", "variant"], {
          is: (type, variant) =>
            (type === "Optional" || type === "On Registration") && !variant,
          then: (schema) =>
            schema
              .typeError("Required")
              .required("Required")
              .min(0, "Amount must be greater than or equal to 0"),
          otherwise: (schema) => schema.notRequired(),
        }),
      minAmount: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : Number(originalValue),
        )
        .when("type", {
          is: "Open Amount",
          then: (schema) =>
            schema
              .typeError("Required")
              .required("Required")
              .min(1, "Must be greater than 0"),
          otherwise: (schema) => schema.notRequired(),
        }),

      // variantInfo: Yup.array().of(
      //   Yup.object().shape({
      //     amount: Yup.number()
      //       .transform((value, originalValue) =>
      //         originalValue === "" ? undefined : Number(originalValue)
      //       )
      //       .when("openAmount", {
      //         is: true,
      //         then: (schema) =>
      //           schema
      //             .typeError("Required")
      //             .required("Required")
      //             .min(0, "Minimum must be ≥ 0"),
      //         otherwise: (schema) =>
      //           schema
      //             .typeError("Required")
      //             .required("Required")
      //             .min(0, "Amount must be ≥ 0"),
      //       }),
      //   })
      // ),

      //  variantInfo: Yup.array().when("type", {
      //         is: (type) =>
      //           type === "Optional" || type === "On Registration",
      //         then: (schema) =>
      //           schema
      //             .min(1, "At least one variant is required")
      //             .of(
      //               Yup.object().shape({
      //                 name: Yup.string()
      //                   .trim()
      //                   .required("Required"),
      //                    quantity: Yup.number()
      //             .transform((value, originalValue) =>
      //               originalValue === "" ? undefined : Number(originalValue)
      //             )
      //             .typeError("Required")
      //             .required("Required")
      //             .min(1, "Quantity must be greater than 0"),

      //                 amount: Yup.number()
      //                   .transform((value, originalValue) =>
      //                     originalValue === "" ? undefined : Number(originalValue)
      //                   )
      //                   .typeError("Required")
      //                   .required("Required")
      //                   .min(0, "Amount must be ≥ 0"),
      //               })
      //             ),
      //         otherwise: (schema) => schema.notRequired(),
      //       }),
      // variantInfo: Yup.array().when(["type", "variant"], {
      //   is: (type, variant) =>
      //     type === "Optional" && variant === true,
      //   then: (schema) =>
      //     schema
      //       .min(1, "At least one variant is required")
      //       .of(
      //         Yup.object().shape({
      //           name: Yup.string()
      //             .trim()
      //             .required("Required"),

      //           quantity: Yup.number()
      //             .transform((value, originalValue) =>
      //               originalValue === "" ? undefined : Number(originalValue)
      //             )
      //             .typeError("Required")
      //             .required("Required")
      //             .min(1, "Quantity must be greater than 0"),

      //           amount: Yup.number()
      //             .transform((value, originalValue) =>
      //               originalValue === "" ? undefined : Number(originalValue)
      //             )
      //             .typeError("Required")
      //             .required("Required")
      //             .min(0, "Amount must be ≥ 0"),
      //         })
      //       ),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      // variantInfo: Yup.array().when(["type", "variant"], {
      //   is: (type, variant) =>
      //     (type === "Optional" || type === "On Registration") && variant === true,
      //   then: (schema) =>
      //     schema
      //       .min(1, "At least one variant is required")
      //       .of(
      //         Yup.object().shape({
      //           name: Yup.string()
      //             .trim()
      //             .required("Required"),

      //         //   quantity: Yup.number()
      //         //     .transform((value, originalValue) =>
      //         //       originalValue === "" ? undefined : Number(originalValue)
      //         //     )
      //         //     .when("type", {
      //         //       is: () => false, // quantity NOT required for On Registration
      //         //       then: (s) => s,
      //         //     }),
      //           quantity:
      //             type === "Optional"
      //               ? Yup.number()
      //                   .transform((value, originalValue) =>
      //                     originalValue === "" ? undefined : Number(originalValue)
      //                   )
      //                   .typeError("Required")
      //                   .required("Required")
      //                   .min(1, "Quantity must be greater than 0")
      //               : Yup.number().notRequired(),

      //           amount: Yup.number()
      //             .transform((value, originalValue) =>
      //               originalValue === "" ? undefined : Number(originalValue)
      //             )
      //             .typeError("Required")
      //             .required("Required")
      //             .min(0, "Amount must be ≥ 0"),
      //         })
      //       ),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      variantInfo: Yup.array().when(["type", "variant"], {
        is: (type, variant) => type === "Optional" && variant === true,
        then: (schema) =>
          schema.min(1, "At least one variant is required").of(
            Yup.object().shape({
              name: Yup.string().trim().required("Required"),

            //   quantity: Yup.number()
            //     .transform((value, originalValue) =>
            //       originalValue === "" ? undefined : Number(originalValue),
            //     )
            //     .typeError("Required")
            //     .required("Required")
            //     .min(1, "Quantity must be greater than 0"),
quantity: Yup.number()
  .nullable()
  .transform((value, originalValue) =>
    originalValue === "" || originalValue === null
      ? undefined
      : Number(originalValue)
  )
  .when("infiniteQuantity", {
    is: false,
    then: (schema) =>
      schema
        .typeError("Required")
        .required("Required")
        .min(1, "Quantity must be greater than 0"),
    otherwise: (schema) =>
      schema.notRequired().nullable(),
  }),
              amount: Yup.number()
                .transform((value, originalValue) =>
                  originalValue === "" ? undefined : Number(originalValue),
                )
                .typeError("Required")
                .required("Required")
                .min(0, "Amount must be ≥ 0"),
            }),
          ),

        otherwise: (schema) =>
          schema.when(["type", "variant"], {
            is: (type, variant) =>
              type === "On Registration" && variant === true,
            then: (schema2) =>
              schema2.min(1, "At least one variant is required").of(
                Yup.object().shape({
                  name: Yup.string().trim().required("Required"),

                  amount: Yup.number()
                    .transform((value, originalValue) =>
                      originalValue === "" ? undefined : Number(originalValue),
                    )
                    .typeError("Required")
                    .required("Required")
                    .min(0, "Amount must be ≥ 0"),

                  quantity: Yup.number().notRequired(),
                }),
              ),

            otherwise: (schema2) => schema2.notRequired(),
          }),
      }),
      ledger: Yup.object().when("type", {
        is: (type) => type !== "No Payment Needed",
        then: (schema) =>
          schema
            .nullable()
            .test(
              "ledger-required",
              "Required",
              (value) => value && Object.keys(value).length > 0,
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
      //       quantity: Yup.number()
      //   .transform((value, originalValue) =>
      //     originalValue === "" ? undefined : Number(originalValue)
      //   )
      //   .when("type", {
      //     is: (type) =>
      //       type === "Optional" || type === "Open Amount",
      //     then: (schema) =>
      //       schema
      //         .typeError("Required")
      //         .required("Required")
      //         .min(1, "Quantity must be greater than 0"),
      //     otherwise: (schema) => schema.notRequired(),
      //   }),
      quantity: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : Number(originalValue),
        )
        .when(["type", "variant", "infiniteQuantity", "limitType"], {
          is: (type, variant, infiniteQuantity, limitType) =>
            (type === "Optional" || type === "Open Amount") && !variant && !infiniteQuantity && limitType !== "checkbox",
          then: (schema) =>
            schema
              .typeError("Required")
              .required("Required")
              .min(1, "Quantity must be greater than 0"),
          otherwise: (schema) => schema.notRequired(),
        }),

    //   installmentDetailsTransaction: Yup.object().when(
    //     "isInstallmentTransaction",
    //     {
    //       is: true,
    //       then: Yup.object().shape({
    //         numberOfInstallment: Yup.number()
    //           .typeError("Required")
    //           .required("Required")
    //           .min(1, "Must be greater than 0"),

            
    //       }),
    //       otherwise: Yup.object().notRequired(),
    //     },
    //   ),
//     installmentDetailsTransaction: Yup.object()
//   .nullable()
//   .when("isInstallmentTransaction", {
//     is: true,
//     then: Yup.object().shape({
//       numberOfInstallment: Yup.number()
//         .transform((value, originalValue) =>
//           originalValue === "" ? undefined : Number(originalValue)
//         )
//         .typeError("Required")
//         .required("Required")
//         .min(1, "Must be greater than 0"),

//       lastInstallmentDate: Yup.date()
//         .nullable()
//         .required("Required"),
//     }),
//     otherwise: Yup.mixed().notRequired(),
//   }),
// installmentDetailsTransaction: Yup.object()
//   .nullable()
//   .when("isInstallmentTransaction", {
//     is: true,
//     then: (schema) =>
//       schema.shape({
//         numberOfInstallment: Yup.number()
//           .transform((value, originalValue) =>
//             originalValue === "" ? undefined : Number(originalValue)
//           )
//           .typeError("Required")
//           .required("Required")
//           .min(1, "Must be greater than 0"),

//         lastInstallmentDate: Yup.date()
//           .nullable()
//           .required("Required"),
//       }),
//     otherwise: (schema) => schema.notRequired(),
//   }),
// installmentDetailsTransaction: Yup.object()
//   .nullable()
//   .when("allowInstallment", {
//     is: true,
//     then: (schema) =>
//       schema.shape({
//         numberOfInstallment: Yup.number()
//           .transform((value, originalValue) =>
//             originalValue === "" ? undefined : Number(originalValue)
//           )
//           .typeError("Required")
//           .required("Required")
//           .min(1, "Must be greater than 0"),

//         lastInstallmentDate: Yup.date()
//           .nullable()
//           .required("Required"),
//       }),
//     otherwise: (schema) => schema.notRequired(),
//   }),
// installmentDetailsTransaction: Yup.object().when(
//   "allowInstallment",
//   (allowInstallment, schema) => {
//     if (!allowInstallment) {
//       return schema.strip(); // 🔥 completely remove from validation
//     }

//     return schema.shape({
//       numberOfInstallment: Yup.number()
//         .transform((value, originalValue) =>
//           originalValue === "" ? undefined : Number(originalValue)
//         )
//         .typeError("Required")
//         .required("Required")
//         .min(1, "Must be greater than 0"),

//       lastInstallmentDate: Yup.date()
//         .nullable()
//         .required("Required"),
//     });
//   }
// ),
// installmentDetailsTransaction: Yup.object().when(
//   "isInstallmentTransaction",
//   (isInstallmentTransaction, schema) => {
//     if (!isInstallmentTransaction) {
//       return schema.strip();
//     }

//     return schema.shape({
//       numberOfInstallment: Yup.number()
//         .transform((value, originalValue) =>
//           originalValue === "" ? undefined : Number(originalValue)
//         )
//         .typeError("Required")
//         .required("Required")
//         .min(1, "Must be greater than 0"),

//     //   lastInstallmentDate: Yup.date()
//     //     .nullable()
//     //     .required("Required"),
//     });
//   }
// ),
// installmentDetailsTransaction: Yup.object()
//   .nullable()
//   .when("isInstallmentTransaction", {
//     is: true,
//     then: Yup.object().shape({
//       numberOfInstallment: Yup.number()
//         .transform((value, originalValue) =>
//           originalValue === "" ? undefined : Number(originalValue)
//         )
//         .typeError("Required")
//         .required("Required")
//         .min(1, "Must be greater than 0"),
//     }),
//     otherwise: Yup.mixed().notRequired(),
//   }),
installmentDetailsTransaction: Yup.object().when(
  ["isInstallmentTransaction"],
  {
    is: (isInstallmentTransaction) => isInstallmentTransaction === true,
    then: Yup.object().shape({
      numberOfInstallment: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : Number(originalValue)
        )
        .typeError("Required")
        .required("Required")
        .min(1, "Required"),
    }),
    otherwise: Yup.object().strip(),
  }
),
// discount: Yup.array().when("freeForm", {
//   is: true,
//   then: (schema) => schema.notRequired().strip(),
//   otherwise: (schema) =>
//     schema.of(
//       Yup.object().shape({
//         discount_name: Yup.string()
//           .trim()
//           .required("Required"),

//         price_type: Yup.string()
//           .required("Required"),

//         value: Yup.number()
//           .transform((value, originalValue) =>
//             originalValue === "" ? undefined : Number(originalValue)
//           )
//           .typeError("Required")
//           .required("Required")
//           .min(0, "Must be greater than or equal to 0"),

//         discount_type: Yup.string()
//           .required("Required"),

//         start_date: Yup.date().when("discount_type", {
//           is: (type) => type?.toLowerCase() === "date",
//           then: (schema) => schema.required("Required"),
//           otherwise: (schema) => schema.notRequired(),
//         }),

//         end_date: Yup.date().when("discount_type", {
//           is: (type) => type?.toLowerCase() === "date",
//           then: (schema) =>
//             schema
//               .required("Required")
//               .min(
//                 Yup.ref("start_date"),
//                 "End date must be after start date"
//               ),
//           otherwise: (schema) => schema.notRequired(),
//         }),

//         quantity: Yup.number().when("discount_type", {
//           is: (type) => type?.toLowerCase() === "quantity",
//           then: (schema) =>
//             schema
//               .transform((value, originalValue) =>
//                 originalValue === "" ? undefined : Number(originalValue)
//               )
//               .typeError("Required")
//               .required("Required")
//               .min(1, "Must be greater than 0"),
//           otherwise: (schema) => schema.notRequired(),
//         }),

//         amount: Yup.number().when("discount_type", {
//           is: (type) => type?.toLowerCase() === "amount",
//           then: (schema) =>
//             schema
//               .transform((value, originalValue) =>
//                 originalValue === "" ? undefined : Number(originalValue)
//               )
//               .typeError("Required")
//               .required("Required")
//               .min(1, "Must be greater than 0"),
//           otherwise: (schema) => schema.notRequired(),
//         }),

//         forMemberOnly: Yup.boolean().notRequired(),
//       })
//     ),
// }),

// discount_name: up.string()
    //   .trim()
    //   .required("Required"),
// discount: Yup.array().when("freeForm", {
//   is: true,
//   then: (schema) => schema.notRequired().strip(),
//   otherwise: (schema) =>
//     schema.of(
//       Yup.object().shape({
//         discount_name: Yup.string()
//           .trim()
//           .required("Required"),

//         price_type: Yup.string()
//           .required("Required"),

//         value: Yup.number()
//           .transform((value, originalValue) =>
//             originalValue === "" ? undefined : Number(originalValue)
//           )
//           .typeError("Required")
//           .required("Required")
//           .min(0, "Must be greater than or equal to 0"),

//         discount_type: Yup.string()
//           .required("Required"),

//         start_date: Yup.date().when("discount_type", {
//           is: (type) => type?.toLowerCase() === "date",
//           then: (schema) => schema.required("Required"),
//           otherwise: (schema) => schema.notRequired(),
//         }),

//         end_date: Yup.date().when("discount_type", {
//           is: (type) => type?.toLowerCase() === "date",
//           then: (schema) =>
//             schema
//               .required("Required")
//               .min(
//                 Yup.ref("start_date"),
//                 "End date must be after start date"
//               ),
//           otherwise: (schema) => schema.notRequired(),
//         }),

//         quantity: Yup.number().when("discount_type", {
//           is: (type) => type?.toLowerCase() === "quantity",
//           then: (schema) =>
//             schema
//               .transform((value, originalValue) =>
//                 originalValue === "" ? undefined : Number(originalValue)
//               )
//               .typeError("Required")
//               .required("Required")
//               .min(1, "Must be greater than 0"),
//           otherwise: (schema) => schema.notRequired(),
//         }),

//         amount: Yup.number().when("discount_type", {
//           is: (type) => type?.toLowerCase() === "amount",
//           then: (schema) =>
//             schema
//               .transform((value, originalValue) =>
//                 originalValue === "" ? undefined : Number(originalValue)
//               )
//               .typeError("Required")
//               .required("Required")
//               .min(1, "Must be greater than 0"),
//           otherwise: (schema) => schema.notRequired(),
//         }),

//         forMemberOnly: Yup.boolean().notRequired(),
//       })
//     ),
// }),
// discount: Yup.array().of(
//   Yup.object().shape({
    // discount_name: up.string()
    //   .trim()
    //   .required("Required"),
//   })
// )

// discount: Yup.array().of(
//   Yup.object().shape({
//     discount_name: Yup.string()
//       .trim()
//       .required("Required"),

//     price_type: Yup.string()
//       .required("Required"),

//     value: Yup.number()
//       .transform((value, originalValue) =>
//         originalValue === "" ? undefined : Number(originalValue)
//       )
//       .typeError("Required")
//       .required("Required")
//       .min(0, "Must be greater than or equal to 0"),

//     discount_type: Yup.string()
//       .required("Required"),

//     start_date: Yup.date().when("discount_type", {
//       is: (type) => type?.toLowerCase() === "date",
//       then: (schema) =>
//         schema
//           .required("Required"),
//       otherwise: (schema) => schema.notRequired(),
//     }),

//     end_date: Yup.date().when("discount_type", {
//       is: (type) => type?.toLowerCase() === "date",
//       then: (schema) =>
//         schema
//           .required("Required")
//           .min(
//             Yup.ref("start_date"),
//             "End date must be after start date"
//           ),
//       otherwise: (schema) => schema.notRequired(),
//     }),

//     quantity: Yup.number().when("discount_type", {
//       is: (type) => type?.toLowerCase() === "quantity",
//       then: (schema) =>
//         schema
//           .transform((value, originalValue) =>
//             originalValue === "" ? undefined : Number(originalValue)
//           )
//           .typeError("Required")
//           .requireYd("Required")
//           .min(1, "Must be greater than 0"),
//       otherwise: (schema) => schema.notRequired(),
//     }),

//     amount: Yup.number().when("discount_type", {
//       is: (type) => type?.toLowerCase() === "amount",
//       then: (schema) =>
//         schema
//           .transform((value, originalValue) =>
//             originalValue === "" ? undefined : Number(originalValue)
//           )
//           .typeError("Required")
//           .required("Required")
//           .min(1, "Must be greater than 0"),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//   })
// ),
    }),
  ),
}),
discount: Yup.array()
  .nullable()
  .when("freeForm", {
    is: false,
    then: (schema) =>
      schema.of(
        Yup.object().shape({
          discount_name: Yup.string()
            .trim()
            .required("Required")
            .test('unique-discount-name', 'Discount name already exists', function(value) {
              if (!value?.trim()) return true;
              const allDiscounts = this.from?.[1]?.value?.discount || [];
              const match = this.path.match(/\[(\d+)\]/);
              const currentIndex = match ? parseInt(match[1]) : -1;
              return !allDiscounts.some((d, i) =>
                i !== currentIndex &&
                d?.discount_name?.trim()?.toLowerCase() === value.trim().toLowerCase()
              );
            }),

          price_type: Yup.string()
            .required("Required"),

          value: Yup.number()
            .transform((value, originalValue) =>
              originalValue === "" ? undefined : Number(originalValue)
            )
            .typeError("Required")
            .required("Required")
            .min(0, "Must be greater than or equal to 0"),

          discount_type: Yup.string()
            .required("Required"),

          start_date: Yup.date()
            .nullable()
            .when("discount_type", {
              is: (type) => type?.toLowerCase() === "date",
              then: (schema) => schema.required("Required"),
              otherwise: (schema) => schema.nullable(),
            }),

          end_date: Yup.date()
            .nullable()
            .when("discount_type", {
              is: (type) => type?.toLowerCase() === "date",
              then: (schema) =>
                schema
                  .required("Required")
                  .min(
                    Yup.ref("start_date"),
                    "End date must be after start date"
                  ),
              otherwise: (schema) => schema.notRequired(),
            }),

          quantity: Yup.number()
            .nullable()
            .when("discount_type", {
              is: (type) => type?.toLowerCase() === "quantity",
              then: (schema) =>
                schema
                  .transform((value, originalValue) =>
                    originalValue === "" ? undefined : Number(originalValue)
                  )
                  .typeError("Required")
                  .required("Required")
                  .min(1, "Must be greater than 0"),
              otherwise: (schema) => schema.notRequired(),
            }),

          amount: Yup.number()
            .nullable()
            .when("discount_type", {
              is: (type) => type?.toLowerCase() === "amount",
              then: (schema) =>
                schema
                  .transform((value, originalValue) =>
                    originalValue === "" ? undefined : Number(originalValue)
                  )
                  .typeError("Required")
                  .required("Required")
                  .min(1, "Must be greater than 0"),
              otherwise: (schema) => schema.notRequired(),
            }),

          forMemberOnly: Yup.boolean().notRequired(),
        })
      ),
    otherwise: (schema) => schema.strip(),
  }),
})